/*
 * Fragstalk: search popup (replaces assets/predictive-search.js).
 * Changes from the theme original:
 *  - Out-of-stock products are mixed in by relevance ("show") instead of pushed
 *    to the end ("last"), so a sold-out exact match is no longer hidden below
 *    10 in-stock look-alikes.
 *  - Products get their own 10 result slots (limit_scope=each) and Shopify's
 *    full field set is searched (the old fixed field list is removed), which
 *    keeps typo tolerance and synonyms working on titles, tags and types.
 *  - Adds an "All / Full bottles / Decants & Partials" switch above the box.
 *    Full/Decant suggestions come from sections/fs-type-search.liquid, and
 *    pressing Enter opens /search with the matching Product type filter.
 */
(function () {
  var DECANT_TYPE = 'Decant & Partial';
  var FULL_TYPES = ['Perfume', 'Attar', 'Body Mist', 'Deodorant & Body Spray', 'Gift Set', 'Bakhoor & Incense', 'Sample & Discovery Set'];
  var UNAVAILABLE = 'show';
  var MODES = [
    { id: 'all', label: 'All' },
    { id: 'full', label: 'Full bottles' },
    { id: 'decant', label: 'Decants & Partials' }
  ];
  var MODE_KEY = 'fsSearchMode';

  function readMode() {
    try {
      var m = sessionStorage.getItem(MODE_KEY);
      if (m === 'full' || m === 'decant') return m;
    } catch (e) {}
    return 'all';
  }

  function saveMode(m) {
    try { sessionStorage.setItem(MODE_KEY, m); } catch (e) {}
  }

  function searchRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'search';
  }

  function injectStyles() {
    if (document.getElementById('fs-search-mode-style')) return;
    var style = document.createElement('style');
    style.id = 'fs-search-mode-style';
    style.textContent =
      '.fs-search-modes{display:flex;gap:8px;flex-wrap:wrap;justify-content:center;margin:0 0 10px;width:100%}' +
      '.fs-search-modes button{border:1px solid #d6d6d6;background:#fff;color:#151515;border-radius:40px;padding:6px 14px;font-size:13px;line-height:1.2;cursor:pointer}' +
      '.fs-search-modes button[aria-pressed="true"]{background:#151515;border-color:#151515;color:#fff}';
    document.head.appendChild(style);
  }

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        searchQuery: '[data-query]',
        searchMessage: '[data-message]',
        input: '[data-search-input]',
        submit: 'button[type="submit"]',
        loading: '[data-spinner]',
        clear: '[data-clear-search]',
        popularSearchItems: ['[data-ps-item]'],
        moreResultIcon: '[data-more-result-icon]'
      };
      this.container = document.querySelector('[data-search-popup]');
      this.domNodes = queryDomNodes(this.selectors, this.container);
      this.cachedResults = {};
      this.transitionDuration = 300;
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form.m-search-form');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.searchPopupSearults = this.querySelector('.m-search-popup__result');
      this.popularSearches = this.querySelector('[data-popular-searches]');
      this.searchCount = this.querySelector('[data-search-count]');
      this.mode = readMode();
      this.requestId = 0;
      this.setUnavailableInput();
      this.renderModeSwitch();
      this.setupEventListeners();
    }

    setPopularSearchesLink = () => {
      const { popularSearchItems } = this.domNodes;
      popularSearchItems.forEach((item) => (item.href = createSearchLink(item.dataset.psQuery)));
    };

    setUnavailableInput() {
      const input = this.form && this.form.querySelector('input[name="options[unavailable_products]"]');
      if (input) input.value = UNAVAILABLE;
    }

    renderModeSwitch() {
      if (!this.form) return;
      injectStyles();
      const wrap = document.createElement('div');
      wrap.className = 'fs-search-modes';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Search in');
      MODES.forEach((m) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.fsMode = m.id;
        btn.textContent = m.label;
        btn.setAttribute('aria-pressed', String(m.id === this.mode));
        btn.addEventListener('click', () => this.setMode(m.id));
        wrap.appendChild(btn);
      });
      this.form.parentNode.insertBefore(wrap, this.form);
      this.modeSwitch = wrap;
      this.updatePlaceholder();
    }

    updatePlaceholder() {
      if (!this.input) return;
      if (!this.input.dataset.fsPlaceholder) this.input.dataset.fsPlaceholder = this.input.placeholder || '';
      if (this.mode === 'full') this.input.placeholder = 'Search full bottles';
      else if (this.mode === 'decant') this.input.placeholder = 'Search decants & partials';
      else this.input.placeholder = this.input.dataset.fsPlaceholder;
    }

    setMode(mode) {
      if (mode === this.mode) return;
      this.mode = mode;
      saveMode(mode);
      this.modeSwitch.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.fsMode === mode)));
      this.updatePlaceholder();
      this.input.focus();
      if (this.getQuery().length) this.getSearchResults(this.getQuery());
    }

    setupEventListeners() {
      const { clear } = this.domNodes;
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('input', debounce((e) => { this.onChange(e); }, 300).bind(this));
      clear.addEventListener('click', this.onClearSearch.bind(this));
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.closeSearchPopup, () => this.close(true));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const q = this.getQuery();
      q.length ? this.getSearchResults(q) : this.close(true);
    }

    onFormSubmit(e) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
        e.preventDefault();
        return;
      }
      this.setUnavailableInput();
      this.form.querySelectorAll('input[data-fs-filter]').forEach((el) => el.remove());
      let types = [];
      if (this.mode === 'decant') types = [DECANT_TYPE];
      if (this.mode === 'full') types = FULL_TYPES;
      types.forEach((t) => {
        const el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'filter.p.product_type';
        el.value = t;
        el.dataset.fsFilter = '';
        this.form.appendChild(el);
      });
    }

    onClearSearch(e) {
      e.preventDefault();
      this.input.value = '';
      this.onChange();
    }

    buildUrl(q) {
      if (this.mode === 'all') {
        return (
          window.MinimogSettings.routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[limit]=10&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=' + UNAVAILABLE +
          '&section_id=predictive-search'
        );
      }
      return (
        searchRoot() +
        '?q=' + encodeURIComponent(q) +
        '&type=product&options[unavailable_products]=' + UNAVAILABLE +
        '&section_id=fs-type-search'
      );
    }

    extractResults(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (this.mode === 'all') {
        const section = doc.querySelector('#shopify-section-predictive-search');
        return section ? section.innerHTML : '<div data-search-items-wrapper></div>';
      }
      const group = doc.querySelector('[data-fs-group="' + this.mode + '"]');
      return group ? group.innerHTML : '<div data-search-items-wrapper></div>';
    }

    getSearchResults(q) {
      const key = this.mode + ':' + q.toLowerCase().replace(/\s+/g, '-');
      this.toggleSpinnerLoading(true);
      this.toggleClearSearch(false);
      if (this.cachedResults[key]) {
        this.renderSearchResults(this.cachedResults[key]);
        return;
      }
      const requestId = ++this.requestId;
      fetch(this.buildUrl(q))
        .then((res) => {
          if (!res.ok) {
            const err = new Error(res.status);
            this.close();
            throw err;
          }
          return res.text();
        })
        .then((html) => {
          const results = this.extractResults(html);
          this.cachedResults[key] = results;
          // Ignore answers to older keystrokes or a previous mode.
          if (requestId !== this.requestId) return;
          this.renderSearchResults(results);
        })
        .catch((err) => {
          this.close();
          throw err;
        });
    }

    renderSearchResults(html) {
      this.predictiveSearchResults.innerHTML = html;
      this.setAttribute('results', true);
      const wrapper = this.querySelector('[data-search-items-wrapper]');
      this.renderSearchQueryAndMessage(!!wrapper && wrapper.childElementCount > 0);
      this.toggleSpinnerLoading(false);
      this.toggleClearSearch(true);
      this.open();
    }

    renderSearchQueryAndMessage(hasResults) {
      const { input, searchQuery, searchMessage, moreResultIcon } = this.domNodes;
      const { resultsTitle } = searchMessage.dataset;
      searchQuery.textContent = input.value;
      this.predictiveSearchResults.classList.remove('m:hidden');
      this.searchPopupSearults.classList.remove('m:hidden');
      searchMessage.textContent = resultsTitle;
      if (hasResults) moreResultIcon.classList.add('m:hidden');
      else moreResultIcon.classList.remove('m:hidden');
    }

    toggleSpinnerLoading(show) {
      const { loading, submit } = this.domNodes;
      submit.style.visibility = show ? 'hidden' : 'visible';
      loading.style.visibility = show ? 'visible' : 'hidden';
    }

    toggleClearSearch(show) {
      const { clear } = this.domNodes;
      clear.style.visibility = show ? 'visible' : 'hidden';
    }

    open() {
      this.searchPopupSearults.style.setProperty('--search-result-max-height', `${this.resultsMaxHeight || this.getResultsMaxHeight()}px`);
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      this.popularSearches && this.popularSearches.classList.add('m:hidden');
      this.searchCount.classList.remove('m:hidden');
    }

    close(clearInput = false) {
      if (clearInput) {
        this.input.value = '';
        this.removeAttribute('results');
        this.toggleClearSearch(false);
        this.resultsMaxHeight = false;
      }
      this.removeAttribute('open');
      this.predictiveSearchResults.classList.add('m:hidden');
      this.searchPopupSearults.classList.add('m:hidden');
      this.popularSearches && this.popularSearches.classList.remove('m:hidden');
      this.searchCount.classList.add('m:hidden');
    }

    getResultsMaxHeight() {
      this.resultsMaxHeight = window.innerHeight - document.querySelector('predictive-search').getBoundingClientRect().bottom;
      return this.resultsMaxHeight;
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
})();
